import React from 'react'
import { Group } from '@mantine/core'
import { AppText } from '../../app/common/ui'
import FieldHelpIcon from './FieldHelpIcon'

export interface LabelWithHelpProps {
  label: string
  required?: boolean
  onHelpClick: () => void
}

export default function LabelWithHelp ({ label, required, onHelpClick }: LabelWithHelpProps) {
  return (
    <Group spacing={4} sx={{ marginBottom: 4 }} align="center" noWrap>
      <AppText component="label" size="sm" weight={500} sx={{ lineHeight: 1.2 }}>
        {label}
        {required ? ' (required)' : ''}
      </AppText>
      <FieldHelpIcon label={label} onClick={onHelpClick} />
    </Group>
  )
}
